function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Fill 1");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M26.5,9.65867585 C26.5,4.36965414 21.0029981,0.5 12.9730887,0.5 C5.47807161,0.5 0.5,4.15611587 0.5,7.84382216 C0.5,9.55602719 2.0685564,10.6804862 3.95117343,10.6804862 C4.93559939,10.6804862 5.43122029,10.3576215 6.16512594,9.41537273 C6.09491564,9.50551451 6.63181447,8.80468614 6.79093604,8.61020423 C8.13573948,6.96655558 9.75859391,6.17316008 12.7754734,6.17316008 C16.5797119,6.17316008 19.2024224,7.78713978 19.2024224,10.6536798 C19.2024224,12.7799029 17.9261462,14.3120584 15.2840931,16.1721755 C15.2773454,16.1769261 13.5536896,17.357459 13.1455327,17.6652723 C10.3758292,19.7877008 8.92925816,22.151224 8.92925816,26.1660019 C8.92925816,28.8917714 9.5882156,29.587913 12.0511356,29.587913 C14.5580263,29.587913 15.4363743,28.875041 15.4363743,27.6879802 C15.4363743,23.695378 16.0304236,22.25966 19.3400258,19.9596916 C21.0094605,18.805462 22.3333216,17.7255779 23.6041224,16.2863399 C25.4499552,14.1958531 26.5,11.9797519 26.5,9.65867585 Z M16.6876233,38.6343675 C16.6876233,36.4658832 14.6189793,34.6270414 12.1168815,34.6270414 C9.62914021,34.6270414 7.61207439,36.4525811 7.61207439,38.6343675 C7.61207439,40.8009853 9.60953195,42.6416936 12.1168815,42.6416936 C14.6380728,42.6416936 16.6876233,40.7870996 16.6876233,38.6343675 Z",
  id: "Fill-1",
  stroke: "#FFFFFF",
  fill: "#FFFFFF"
}));

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "27px",
    height: "44px",
    viewBox: "0 0 27 44",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.5615bc88.svg";
export { ForwardRef as ReactComponent };